import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../AuthContext';
import { FaBars, FaTimes } from 'react-icons/fa';
import '../styles/Header.css';

const Header = () => {
  const { currentUser, logout, isAdmin } = useAuth();
  const location = useLocation();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);

  // Fonction pour basculer le menu mobile
  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
    setDropdownOpen(false); // Fermer le dropdown si le menu mobile est ouvert/fermé
  };

  // Fonction pour basculer le menu déroulant
  const toggleDropdown = () => {
    setDropdownOpen(!dropdownOpen);
  };

  // Fonction pour fermer le menu mobile lors de la navigation
  const closeMobileMenu = () => {
    setMobileMenuOpen(false);
    setDropdownOpen(false);
  };

  return (
    <header className="App-header">
      <div className="container header-container">
        <div className="logo">
          <Link to="/">
            <img src="/images/logo.png" alt="Conclave 2025" className="logo-img" />
            <span className="logo-text">Conclave 2025</span>
          </Link>
        </div>
        
        <div className="mobile-menu-toggle" onClick={toggleMobileMenu}>
          {mobileMenuOpen ? <FaTimes /> : <FaBars />}
        </div>
        
        <nav className={`nav-container ${mobileMenuOpen ? 'mobile-menu-open' : ''}`}>
          <ul className="nav-links">
            <li><Link to="/cardinaux" onClick={closeMobileMenu} className={location.pathname.includes('/cardinaux') ? 'active' : ''}>Cardinaux</Link></li>
            <li><Link to="/papabili" onClick={closeMobileMenu} className={location.pathname.includes('/papabili') ? 'active' : ''}>Papabili</Link></li>
            <li><Link to="/actualites" onClick={closeMobileMenu} className={location.pathname.includes('/actualites') ? 'active' : ''}>Actualités</Link></li>
            <li><Link to="/conclave" onClick={closeMobileMenu} className={location.pathname.includes('/conclave') ? 'active' : ''}>Conclave Virtuel</Link></li>
            <li><Link to="/quiz" onClick={closeMobileMenu} className={location.pathname.includes('/quiz') ? 'active' : ''}>Quiz</Link></li>
	        <li><Link to="/galeries" onClick={closeMobileMenu} className={location.pathname.includes('/galeries') ? 'active' : ''}>Galeries</Link></li>
         </ul>
        
          <div className="auth-section">
            {currentUser ? (
              <div className="user-menu">
                <span className="username" onClick={toggleDropdown}>
                  Bonjour, {currentUser.name}
                  {/* Option: ajouter une icône de flèche ici */}
                </span>
                
                {isAdmin() && (
                  <div className={`dropdown-menu ${dropdownOpen ? 'show' : ''}`}>
                    <Link to="/admin/cardinaux" onClick={closeMobileMenu} className="dropdown-item">
                      Gestion des Cardinaux
                    </Link>
                    <Link to="/admin/articles" onClick={closeMobileMenu} className="dropdown-item">
                      Gestion des news
                    </Link>                 
					<Link to="/admin/papabile-jour" onClick={closeMobileMenu} className="dropdown-item">
                      Papabile du Jour
                    </Link>
                    <Link to="/admin/conclave" onClick={closeMobileMenu} className="dropdown-item">
                      Gestion du Conclave
                    </Link>
                    <Link to="/admin/quiz" onClick={closeMobileMenu} className="dropdown-item">
                      Gestion du Quiz
                    </Link>
					<Link to="/admin/gallery" onClick={closeMobileMenu} className="dropdown-item">
                      Gérer les Galeries
                    </Link>
                    <div className="dropdown-divider"></div>
                    <button onClick={logout} className="dropdown-item logout-item">
                      Déconnexion
                    </button>
                  </div>
                )}
                
                {!isAdmin() && (
                  <button onClick={logout} className="logout-button">
                    Déconnexion
                  </button>
                )}
              </div>
            ) : (
              <Link to="/login" onClick={closeMobileMenu} className="login-button">Connexion</Link>
            )}
          </div>
        </nav>
      </div>
    </header>
  );
};

export default Header;